var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22301",
    "data-name": "\\uADF8\\uB8F9 22301",
    transform: "translate(-1386 -7712)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28543",
    "data-name": "\\uC0AC\\uAC01\\uD615 28543",
    width: 24,
    height: 24,
    transform: "translate(1386 7712)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram-filled",
    transform: "translate(1387.611 7713.611)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1208",
    "data-name": "\\uD0C0\\uC6D0 1208",
    cx: 3.513,
    cy: 3.513,
    r: 3.513,
    transform: "translate(6.906 6.875)",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10326",
    "data-name": "\\uD328\\uC2A4 10326",
    d: "M14.235,1H6.542A5.545,5.545,0,0,0,1,6.542v7.632a5.558,5.558,0,0,0,5.542,5.6h7.632a5.558,5.558,0,0,0,5.6-5.542V6.542A5.545,5.545,0,0,0,14.235,1ZM10.419,14.992a4.6,4.6,0,1,1,4.573-4.6A4.6,4.6,0,0,1,10.419,14.992Zm6.36-8.783a1.687,1.687,0,0,1-1.272.515,1.894,1.894,0,0,1-1.272-.515,1.735,1.735,0,0,1-.515-1.272,1.785,1.785,0,0,1,.515-1.272,1.65,1.65,0,0,1,1.272-.545,1.838,1.838,0,0,1,1.272.515,2.217,2.217,0,0,1,.515,1.333A2,2,0,0,1,16.779,6.209Z",
    fill: "#212529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10327",
    "data-name": "\\uD328\\uC2A4 10327",
    d: "M47.327,11.6a.727.727,0,1,0,.727.727A.717.717,0,0,0,47.327,11.6Z",
    transform: "translate(-31.79 -7.39)",
    fill: "#212529"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon5);
export default __webpack_public_path__ + "static/media/FooterIcon5.2bda5c7fc351746910cf3368d3e58629.svg";
export { ForwardRef as ReactComponent };